enum ButtonTheme {
  ACCENT = 'accent',
  DEFAULT = 'default',
  OUTLINE = 'outline',
  PRIMARY = 'primary',
  QUIET_DEFAULT = 'quiet-default',
  QUIET_EMPHASIS = 'quiet-emphasis',
  SECONDARY = 'secondary',
}

export default ButtonTheme;
